import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import log from 'loglevel';
import STRING_KEYS from '../../../../language/keys';
import { useGetMyUserQuery } from '../../../../store/rtk-query/apis/user/user.toolkit-api';
import { useGetAccountByIdQuery } from '../../../../store/rtk-query/apis/account/account.toolkit-api';
import { PerfectButtonVariants } from '../../../Common/Buttons/perfect-base-button/perfect-base-button.enums';
import { useCreateCustomerPortalSessionMutation } from '../../../../store/rtk-query/apis/payment/payment.toolkit-api';
import { PricingPlan } from '../../../../enums/user-plan.enum';
import {
  CurrentPlanDetailsWrapper,
  CurrentPlanSubtitle,
  CurrentPlanTitle,
  CurrentPlanWrapper,
  ManageYourPlanButton,
} from './CurrentPlanDetails.styled';

const logger = log.getLogger('CurrentPlanDetails');

export const CurrentPlanDetails = (): JSX.Element => {
  const { t: translate } = useTranslation();

  const { data: { accountId } = {} } = useGetMyUserQuery();
  const { data: { plan } = {} } = useGetAccountByIdQuery(accountId, {
    skip: !accountId,
  });

  const [
    createCustomerPortalSession,
    { isLoading: isCreatingCustomerPortalSession },
  ] = useCreateCustomerPortalSessionMutation();

  const currentPlanTitle = plan?.isCreditsBased ?
    translate(
      STRING_KEYS.UPGRADE_PLAN_DIALOG.CURRENT_PLAN.CREDITS_BASED_PLAN_DETAILS,
      {
        planDisplayName: plan?.displayName,
        monthlyCredits: plan?.monthlyCredits,
      },
    ) :
    translate(
      STRING_KEYS.UPGRADE_PLAN_DIALOG.CURRENT_PLAN
        .POSITION_BASED_PLAN_DETAILS,
      { planDisplayName: plan?.displayName },
    );

  const handleManageYourPlanClick = async () => {
    try {
      const callbackUrl = new URL(window.location.href).toString();
      const { url } = await createCustomerPortalSession({
        callbackUrl,
      }).unwrap();
      window.open(url, '_blank');
    } catch (e) {
      logger.error(e);
    }
  };

  return (
    <CurrentPlanWrapper>
      <CurrentPlanDetailsWrapper>
        <CurrentPlanTitle>{currentPlanTitle}</CurrentPlanTitle>

        {plan?.isCreditsBased && plan?.nextCreditsRenewalDate && (
          <CurrentPlanSubtitle>
            {translate(
              STRING_KEYS.UPGRADE_PLAN_DIALOG.CURRENT_PLAN.RENEWAL_DATE,
              {
                renewalDate: format(
                  new Date(plan?.nextCreditsRenewalDate),
                  'MMMM do, yyyy',
                ),
              },
            )}
          </CurrentPlanSubtitle>
        )}
      </CurrentPlanDetailsWrapper>

      {plan?.pricingPlan !== PricingPlan.Trial && (
        <ManageYourPlanButton variant={ PerfectButtonVariants.Link }
          onClick={ handleManageYourPlanClick }
          isLoading={ isCreatingCustomerPortalSession }
        >
          {translate(
            STRING_KEYS.UPGRADE_PLAN_DIALOG.CURRENT_PLAN.MANAGE_YOUR_PLAN,
          )}
        </ManageYourPlanButton>
      )}
    </CurrentPlanWrapper>
  );
};
